<template>
    <div>
        <div class="row mb-1" v-if="$safe(value,'Current.EmployeeDepartmentTitle.CollarStatus.Name')">
            <div class="col-12">
                <div class="d-flex align-items-center bg-light rounded p-50 collar-zone mb-0">
                    <collar-status :code="$safe(value,'Current.EmployeeDepartmentTitle.CollarStatus.Code')"></collar-status>
                    <span class="ml-50">{{ $safe(value,'Current.EmployeeDepartmentTitle.CollarStatus.Name') }}</span>
                </div>
            </div>
        </div>

        <div class="bg-light p-50 border rounded mb-50" v-if="value.Current != null">
            <div class="row ">
                <div class="col-md-auto mb-md-0 mb-50">
                    <button class="btn btn-secondary btn-sm w-100" v-on:click="editing = true" :disabled="editing">Düzenle</button>
                </div>
                <div class="col-md-auto mb-md-0 mb-50">
                    <b-form-radio-group :disabled="!editing" button-variant="outline-primary" class="w-100" size="sm" v-model="value.ChangeType" :options="c_changeTypes" buttons></b-form-radio-group>
                </div>
                <div class="col-md-auto">
                    <button class="btn btn-danger btn-sm w-100" v-if="editing" v-on:click="clearEditing">Vazgeç</button>
                </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-3 mb-1">
                <label class="from-label">Şube</label>
                <v-select-list :options="branches" label="Name" v-model="branch" v-on:input="resetBranch" :disabled="!enableBranch" placeholder="Şube"></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="from-label">Unvan</label>
                <v-select-list :options="titles" :disabled="!enableTitle || value.BranchId == null" v-on:input="resetTitle" label="Name" v-model="title" placeholder="Unvan"></v-select-list>
            </div>
            <div class="col-md-3 mb-1" v-if="isDriver">
                <label class="form-label">Görev Yeri</label>
                <v-select-list :disabled="value.BranchId == null || !enableVehicleInventoryGarage" :options="vehicleInventoryGarages" label="GarageName" v-model="vehicleInventoryGarage" placeholder="Görev Yeri"></v-select-list>
            </div>
            <div class="col-md-3 mb-1">
                <label class="form-label">Atama Tarihi</label>
                <v-date-picker v-model="value.Date" :disabled="!enableDate" placeholder="Atama Tarihi"></v-date-picker>
            </div>
            <div class="col-12 text-right mb-1" v-if="value.ChangeType != 0 || value.Current == null">
                <v-executer :loading="loading" :text="changeTypeText" :action="createOrUpdate"></v-executer>
            </div>
        </div>

        <v-table    ref="table"
                    :settings="false"
                    :fields="fields"
                    name="employee-branch"
                    :buttons="buttons"
                    :row-class="active"
                    pagination="server"
                    :items-provider="provider"></v-table>
    </div>
</template>

<script>
import {BCard,BFormRadioGroup} from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import VehicleOperationsApi from '@/api/vehicle-operations'
import CompanyApi from '@/api/company'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import EmployeeBranchCreateOrUpdate from './EmployeeBranchCreateOrUpdate.vue'
import moment from 'moment'
import CollarStatus from '@/views/employee-operations/components/CollarStatus.vue'

export default {
    components:{
        BCard,
        EmployeeBranchCreateOrUpdate,
        BFormRadioGroup,
        CollarStatus
    },
    props:{
        id:[String,Number],
        value:Object,
        getPersonal:Function,
        canBranchAssignable:Boolean
    },
    data(){
        return{
            editing:false,
            loading:false,
            branches:[],
            titles:[],
            vehicleInventoryGarages:[],
            changeTypes:[
                { text: 'Şube Düzenle', value: 1 },
                { text: 'Unvan Düzenle', value: 3 },
                { text: 'Görev Yeri Düzenle', value: 2 },
            ],
            fields:[
                { name:"Şube",key:"Branch.Name",thClass:'w-16',tdClass:'text-nowrap'},
                { name:"Şube Giriş Tarihi",key:"BranchStartDate",thClass:'w-10',tdClass:'text-nowrap'},
                { name:"Şube Çıkış Tarihi",key:"BranchEndDate",thClass:'w-10',tdClass:'text-nowrap'},
                { name:"Unvan",key:"EmployeeDepartmentTitle.Name",thClass:'w-14',tdClass:'text-nowrap'},
                { name:"Unvan Başlangıç Tarihi",key:"TitleStartDate",thClass:'w-10',tdClass:'text-nowrap'},
                { name:"Unvan Bitiş Tarihi",key:"TitleEndDate",thClass:'w-10',tdClass:'text-nowrap'},
                { name:"Görev Yeri",key:"VehicleInventoryGarage.GarageName",thClass:'w-14',tdClass:'text-nowrap'},
                { name:"Görev Yeri Başlangıç Tarihi",key:"GarageStartDate",thClass:'w-10',tdClass:'text-nowrap'},
                { name:"Görev Yeri Bitiş Tarihi",key:"GarageEndDate",thClass:'w-10',tdClass:'text-nowrap'},
            ],
            buttons:[
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    watch:{
        "value.ChangeType"(){
            if(this.value.ChangeType == 1) this.value.Date = this.value.BranchStartDate ? moment(this.value.BranchStartDate,'DD.MM.YYYY').format('YYYY-MM-DD') : null
            else if(this.value.ChangeType == 2) this.value.Date = this.value.GarageStartDate ? moment(this.value.GarageStartDate,'DD.MM.YYYY').format('YYYY-MM-DD') : null
            else if(this.value.ChangeType == 3) this.value.Date = this.value.TitleStartDate ? moment(this.value.TitleStartDate,'DD.MM.YYYY').format('YYYY-MM-DD') : null
            else this.value.Date = null
        },
        "value.BranchId"(){
            this.getTitles()
        },
        "value.EmployeeDepartmentTitleId"(){
            this.getVehicleInventoryGarages()
        }
    },
    mounted(){
        this.getBranches()
        this.getTitles()
        this.getVehicleInventoryGarages()
    },
    methods:{
        active(item){
            return item.Id == this.value.Current?.Id ? 'font-weight-bolder text-primary bg-light-primary' : null
        },
        provider(data){
            return EmployeeOperationsApi.VehicleInventoryGarage.Table(data,this.id)
        },
        resetBranch(){
            this.value.EmployeeDepartmentTitleId = null
        },
        resetTitle(){
            this.value.VehicleInventoryGarageId = null
        },
        clearEditing(){
            this.editing = false
            this.value.ChangeType = 0
        },
        async createOrUpdate(){
            this.loading = true
            EmployeeOperationsApi.VehicleInventoryGarage.Assign({
                ...this.value,
                EmployeeId:this.id,
                CurrentId:this.value.Current?.Id || null
            }).then(res=>{
                if(res.data.Success){
                    this.getPersonal()
                    this.$refs.table.refresh()
                    this.clearEditing()
                    this.value.Date = null
                }
                this.$result(res)
                this.loading = false
            }) .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        getVehicleInventoryGarages(){
            if(this.value.BranchId){
                VehicleOperationsApi.Garage.ListByBranch(this.value.BranchId).then(res=>{
                    this.vehicleInventoryGarages = res.data.Data
                })
            }
        },
        getBranches(){
            CompanyApi.Branch.ListByCode('O').then(res=>{
                this.branches = res.data.Data
            })
        },
        getTitles(){
            if(this.value.BranchId){
                HumanResourcesParameterApi.EmployeeDepartmentTitle.List(this.value.BranchId).then(res=>{
                    this.titles = res.data.Data
                })
            }
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem personelin atamasını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.VehicleInventoryGarage.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                            this.getPersonal()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    },
    computed:{
        changeTypeText(){
            switch (this.value.ChangeType) {
                case 1: return 'Şube Bilgilerini Güncelle'
                case 2: return 'Görev Yeri Bilgilerini Güncelle'
                case 3: return 'Unvan Bilgilerini Güncelle'
                default: return 'Şube Bilgilerini Güncelle'
            }
        },
        enableBranch(){
            if(this.value.Current != null){
                if(this.value.ChangeType == 1) return true
                else return false
            }else return true
        },
        enableTitle(){
            if(this.value.Current != null){
                if(this.value.ChangeType == 1 || this.value.ChangeType == 3) return true
                else return false
            }else return true
        },
        enableVehicleInventoryGarage(){
            if(this.value.Current != null){
                if(this.value.ChangeType == 1 || this.value.ChangeType == 2 || this.value.ChangeType == 3) return true
                else return false
            }else return true
        },
        enableDate(){
            if(this.value.Current != null){
                if(this.value.ChangeType != 0 && this.editing) return true
                else return false
            }else return true
        },
        c_changeTypes(){
            if(this.isDriver){
                return this.changeTypes
            }else return this.changeTypes.filter(ct=>ct.value != 2)
        },
        isDriver(){
            if(this.title){
                return this.title.DriverDepartment || false
            }else return false
        },
        vehicleInventoryGarage:{
            get:function(){
                return this.vehicleInventoryGarages.find(b=>b.Id==this.value.VehicleInventoryGarageId)
            },
            set:function(value){
                this.value.VehicleInventoryGarageId = value?.Id || null
            }
        },
        title:{
            get:function(){
                return this.titles.find(b=>b.Id==this.value.EmployeeDepartmentTitleId)
            },
            set:function(value){
                this.value.EmployeeDepartmentTitleId = value?.Id || null
            }
        },
        branch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.value.BranchId)
            },
            set:function(value){
                this.value.BranchId = value?.Id || null
            }
        },
    }
}
</script>

<style>
.collar-icon{
    font-size: 2.25rem;
}

.collar-zone{
    font-size: 1.75rem;
    line-height: 1.75rem;
    font-weight: 500;
}

.dark-layout .collar-icon {
    color: white !important;
}

.collar-icon.White{
    color: black;
}
.collar-icon.Blue{
    color: var(--primary);
}
.collar-icon.Driver{
    color: var(--success);
}
</style>